import script from "./MenuPases.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuPases.vue?vue&type=script&setup=true&lang=js"

import "./MenuPases.vue?vue&type=style&index=0&id=7bf34d37&lang=css"

const __exports__ = script;

export default __exports__